<template>
    <div class="fields">
        <input type="hidden" name="_token" :value="token">
        <input type="hidden" name="order[shipping_id]" :value="cartData.shipping.id">
        <input type="hidden" name="order[payment_id]" :value="cartData.payment.id">
        <input type="hidden" name="order[discount_coupon_id]" :value="discountCoupon.id" v-if="discountCoupon">
        <input type="hidden" name="order_shippings[is_free]" :value="hasFreeShipping" v-if="hasFreeShipping && cartData.shipping.can_free">
        <template v-for="(value, key) in packeta" v-if="packeta">
            <input type="hidden" :name="`order[attributes][packeta][${key}]`" :value="value">
        </template>
        <template v-for="(service) in orderServices">
            <input type="hidden" :name="`order_services[]`" :value="service.id">
        </template>
        <template v-for="(value, key) in cartData.customer">
            <input type="hidden" :name="`order_details[${key}]`" :value="value">
        </template>
        <template v-for="(product, key) in cartData.products">
            <input type="hidden" :name="`products[${key}][product_variant_id]`" :value="product.product_variant_id">
            <input type="hidden" :name="`products[${key}][quantity]`" :value="product.qty">
            <!-- File -->
            <input v-for="file in product.files" type="hidden" :name="`products[${key}][files][]`" :value="file.id">
            <!-- Attributes -->
            <template v-for="(attributeValue, attributeKey) in product.attributes">
                <input type="hidden" :name="`products[${key}][attributes][${attributeKey}]`" :value="attributeValue"
                    v-if="product.attributes.hasOwnProperty(attributeKey)" />
            </template>
            <!-- Product services -->
            <template v-for="(service) in product.services">
                <input type="hidden" :name="`products[${key}][services][]`" :value="service.id" />
                <!-- !custom -->
                <input type="hidden" :name="`products[${key}][attributes][packagingText]`" :value="service.text" />
                <input type="hidden" :name="`products[${key}][attributes][packagingTheme]`"
                    :value="service.packaging_theme.name" />
            </template>
        </template>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import useGlobal from "../../../useGlobal";
import { empty } from "../../../../helpers";

export default {
    computed: {
        ...mapGetters({
            cartData: 'cart/getCartData',
            packeta: 'packeta/getData',                     // [PACKAGE] - packeta
            discountCoupon: 'discountCoupon/getData',       // [PACKAGE] - discount coupon
            orderServices: 'orderService/getOrderServices',  // [PACKAGE] - order service
            hasFreeShipping: 'cart/getHasFreeShipping',
        })
    },
    setup() {
        const {
            token
        } = useGlobal()

        return {
            token,
            empty
        }
    }
}
</script>
